module.exports = __webpack_public_path__ + "img/check.770ff680.svg";